import { requestNotificationPermission } from "@app/features/subscribe-push/lib/RequestNotificationPermission.tsx";

import { getServiceWorkerRegistration } from "./GetServiceWorkerRegistration";

/**
 * Проверяет возможность и подписывает браузер на пуш-уведомления, если это возможно
 * @param serverKey публичный ключ VAPID для конкретного деплоя конкретной игры
 * @returns Promise, разрешающийся в объект PushSubscription, если все прошло успешно или в undefined
 */
export async function subscribeToPushes(serverKey: string) {
	if (!("serviceWorker" in navigator)) {
		log.warn("[PUSH] Service workers unavailable in browser. Skipping subscription");
		return;
	}
	const registration = await getServiceWorkerRegistration();
	if (!registration) {
		log.warn("[PUSH] No service worker registered. Skipping subscription");
		return;
	}

	try {
		const _ = await requestNotificationPermission();

		log.info("[PUSH] Notification permission granted!");

		const options: PushSubscriptionOptionsInit = {
			userVisibleOnly: true,
			applicationServerKey: serverKey
		};
		return registration.pushManager.subscribe(options);
	} catch (error) {
		log.error("[PUSH] Error while requesting notification permission");
		if (error instanceof Error) {
			log.error(error.message);
		} else {
			log.error(error);
		}

		log.error("[PUSH] Skipping subscription");
	}
}
